"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackDrop = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var config_context_1 = require("../_util/config-context");
function BackDrop(_a) {
    var zIndex = _a.zIndex, _b = _a.style, style = _b === void 0 ? {} : _b;
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", { className: classPrefix + "-backdrop", style: tslib_1.__assign({ zIndex: zIndex }, style) }));
}
exports.BackDrop = BackDrop;
//# sourceMappingURL=BackDrop.js.map